import React from 'react';

const CharitySurfEvent = () => {
  return (
    <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
      <h1>Log 2 Pint — Paddle for the Sea on Winter Solstice</h1>
      
      <p>
        I built this website to support a winter tradition a friend and I started involving paddling from
        Little Wategos to the Beach Road Hotel to raise funds for marine conservation, connect with
        the community, and go surfing.
      </p>

      <p>
        The site is live on Vercel and keeps things intentionally simple with a clear structure and minimal load,
        and just enough design to feel personal without getting in the way. The layout focuses on clarity and 
        action, while hand-drawn illustrations give it character and warmth, more like a note from a friend 
        than a polished ad.
      </p>

      <p>It covers the essentials:</p>
      <ul>
        <li>A short story about the event</li>
        <li>Three clean call-to-actions: 🌊 Register | 📸 Instagram | 💬 Join Chat</li>
        <li>A simple form to capture interest</li>
        <li>Links to the broader community around the cause</li>
      </ul>

      <p>
        Entry is by donation to <strong>Positive Change for Marine Life</strong>.
        All proceeds go directly to the charity — including from a limited run of shirts.
      </p>

      <p>
        👉👉 <strong><a href="https://log2pint.vercel.app" target="_blank" rel="noopener noreferrer">Visit the site</a></strong> 👈👈
      </p>
    </main>
  );
};

export default CharitySurfEvent;
